import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import "bootstrap-icons/font/bootstrap-icons.css";
import "./App.css";
import { useTranslation } from "react-i18next";
import { useEffect } from "react";
import { Route, Routes } from "react-router-dom";
import { useLocation } from "react-router-dom";

import ProtectedRoute from "./components/ProtectedRoute/ProtectedRoute";
import Navbar from "./components/Navbar/Navbar";
import ProductsPage from "./Pages/ProductsPage/ProductsPage";
import Home from "./Pages/Home/Home";
import Footer from "./components/Footer/Footer";
import RawMaterialsPage from "./Pages/MaterialPage/RawMaterialsPage";
import FormulationsPage from "./Pages/FormulationsPage/FormulationPage";


import Login from "./components/auth/login/Login";
import Register from "./components/auth/register/Register";
import ForgotPassword from "./components/auth/forgot-password/ForgotPassword";
import VerifyOtp from "./components/auth/verify-otp/VerifyOtp";
import ResetPassword from "./components/auth/forgot-password/Resetpassword";
import ForgotVerifyOtp from "./components/auth/verify-otp/VerifypasswordOtp";
import SuccessPassword from "./components/auth/SuccessPassword/SucccessPassword";
import SuccessRegister from "./components/auth/SuccessRegister/SuccessRegister";
import ProfilePage from "./Pages/ProfilePage/ProfilePage";
import ProfileMenu from "./components/ProfileMenu/ProfileMenu";
import HelpPage from "./Pages/Terms&PrivacyPages/HelpPage/HelpPage";
import StaticPage from "./Pages/Terms&PrivacyPages/StaticPage/StaticPage";
import OrdersHistory from "./Pages/Orders/OrderHistory";
import CategoriesPage from "./Pages/CategoriesPage/CategoriesPage";
import CategoryDetailPage from "./Pages/CategoriesPage/CategoryDetailPage";
import OrderDetails from "./Pages/Orders/OrderDetails";
import PurchaseOrderChat from "./Pages/Orders/PurchaseOrderChat";
import NotificationsPage from "./Pages/NotificationPage/NotificationPage";

function App() {
  const location = useLocation();

  const authPages = [
    "/login",
    "/register",
    "/forgot-password",
    "/verify-otp",
    "/forgot-verify-otp", 
    "/forgot-password/reset",
    "/reset-password",
    "/success-register", 
    "/success-password",
  ];

  const isAuthPage = authPages.includes(location.pathname);

  const { i18n } = useTranslation();

  useEffect(() => {
    document.documentElement.dir = i18n.language === "en" ? "ltr" : "rtl";
    document.documentElement.lang = i18n.language;
  }, [i18n.language]);

  return (
    <div className="App">
      {!isAuthPage && <Navbar />}

      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/products" element={<ProductsPage />} />
        <Route path="/top-formula" element={<FormulationsPage />} />
        <Route path="/raw-materials" element={<RawMaterialsPage />} />
        <Route path="/categories/*" element={<CategoriesPage />} />
        <Route path="/categories/:id" element={<CategoryDetailPage />} />
        <Route path="/profile" element={<ProfilePage />} />
        <Route path="/profile-menu" element={<ProfileMenu />} />
        <Route path="/orders" element={<OrdersHistory />} />
        <Route path="/orders/:id" element={<OrderDetails />} />
        <Route path="/notifications" element={<NotificationsPage />} />
        <Route path="/help" element={<HelpPage />} />
        <Route path="/orders/:id/chat" element={<PurchaseOrderChat />} />
        <Route
          path="/about"
          element={<StaticPage endpoint="/about-us" title="About RawKemya" />}
        />
        <Route
          path="/terms"
          element={<StaticPage endpoint="/terms" title="Terms & Conditions" />}
        />
        <Route
          path="/privacy"
          element={<StaticPage endpoint="/privacy" title="Privacy Policy" />}
        />
        <Route path="/login" element={<Login />} />
        <Route path="/register" element={<Register />} />
        <Route path="/verify-otp" element={<VerifyOtp />} />
        <Route path="/success-register" element={<SuccessRegister />} />{" "}
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/forgot-verify-otp" element={<ForgotVerifyOtp />} />
        <Route path="/forgot-password/reset" element={<ResetPassword />} />
        <Route path="/success-password" element={<SuccessPassword />} />
      </Routes>

      {!isAuthPage && <Footer />}
    </div>
  );
}

export default App;
